/**
 * Newsletter popup: opens once after a delay, remembers dismissal, and swaps to
 * the discount code after a successful signup. Markup and settings come from
 * snippets/newsletter-popup.liquid.
 */
(function () {
  var dialog = document.querySelector('[data-newsletter-popup]');
  if (!dialog) return;

  var SUBSCRIBED = 'newsletterPopup:subscribed';
  var SNOOZED_UNTIL = 'newsletterPopup:snoozedUntil';
  var PENDING = 'newsletterPopup:pending';

  function read(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) {
      /* Private windows and blocked site data throw; the popup still works, it just can't remember. */
    }
  }

  var delay = (Number(dialog.dataset.delay) || 8) * 1000;
  var snoozeMs = (Number(dialog.dataset.snoozeDays) || 7) * 24 * 60 * 60 * 1000;

  var signup = dialog.querySelector('[data-newsletter-signup]');
  var success = dialog.querySelector('[data-newsletter-success]');
  var successHeading = dialog.querySelector('[data-newsletter-success-heading]');
  var form = dialog.querySelector('[data-newsletter-form]');
  var errorEl = dialog.querySelector('[data-newsletter-error]');
  var submit = form.querySelector('[type="submit"]');
  var copyButton = dialog.querySelector('[data-newsletter-copy]');
  var subscribed = false;

  function showSuccess() {
    subscribed = true;
    write(SUBSCRIBED, '1');
    write(PENDING, null);
    signup.hidden = true;
    success.hidden = false;
    present();
    successHeading.focus();
  }

  function present() {
    if (dialog.open) return;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  }

  /* Wait out the cart drawer, search, or any other modal instead of stacking on it. */
  function openWhenClear(attemptsLeft) {
    if (document.querySelector('dialog[open]')) {
      if (attemptsLeft > 0) window.setTimeout(function () { openWhenClear(attemptsLeft - 1); }, 2000);
      return;
    }
    present();
  }

  dialog.addEventListener('close', function () {
    document.documentElement.style.overflow = '';
    if (!subscribed) write(SNOOZED_UNTIL, String(Date.now() + snoozeMs));
  });

  dialog.querySelectorAll('[data-newsletter-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      dialog.close();
    });
  });

  /* A click on the backdrop lands on the dialog element itself, not on the panel inside it. */
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    errorEl.hidden = true;
    submit.disabled = true;

    window
      .fetch(form.action, {
        method: 'POST',
        body: new window.FormData(form),
        credentials: 'same-origin',
      })
      .then(function (response) {
        if (response.url.indexOf('customer_posted=true') !== -1) {
          showSuccess();
          return;
        }

        /* Shopify sent us to a captcha challenge (or anything else unexpected). Let the browser
           submit the form normally; the page reloads and we pick up again from ?customer_posted. */
        write(PENDING, '1');
        form.submit();
      })
      .catch(function () {
        errorEl.hidden = false;
        submit.disabled = false;
      });
  });

  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var code = dialog.dataset.code;
      var done = function () {
        copyButton.textContent = 'Copied';
      };
      if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
        window.navigator.clipboard.writeText(code).then(done, function () {});
      }
    });
  }

  /* Back from a normal form post (the captcha path): show the code straight away. */
  var params = new window.URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true' && read(PENDING)) {
    params.delete('customer_posted');
    var query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    showSuccess();
    return;
  }

  if (read(SUBSCRIBED)) return;

  var snoozedUntil = Number(read(SNOOZED_UNTIL)) || 0;
  if (snoozedUntil > Date.now()) return;

  window.setTimeout(function () {
    openWhenClear(10);
  }, delay);
})();
